module.exports = __webpack_public_path__ + "assets/img/正骨3.3798eeb4.jpg";